module.exports = __webpack_public_path__ + "static/media/certyfikat-20.f8860758.png";